import { useAbility } from '@cast/shared-ability-data-access';

export const useShowHpaV2 = () => {
  return {
    // true for selected customers
    showHpaV2: useAbility().can('view', 'ClusterWorkloadShowHpaV2'),
  };
};
